<template>
  <v-content class="db-content">
    <v-container grid-list-xl class="lighten-3">
      <v-flex xs12 sm12 md12 x12 class="lg5-custom">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="list" :search="search"></v-data-table>
        </v-card>
      </v-flex>
    </v-container>
  </v-content>
</template>

<script>
// import func from "../../vue-temp/vue-editor-bridge";
export default {
  name: "forms",
  data() {
    return {
      // dialog: false,
      items: [],
      absolute: true,
      overlay: false,

      currentField: 0,
      search: "",
      headers: [
        {
          text: "Country",
          align: "left",
          filterable: true,
          value: "Country",
        },
        { text: "New Confirm Case", value: "NewConfirmed", filterable: false },
        { text: "Total Deaths", value: "TotalDeaths", filterable: false },
        { text: "Total Recover", value: "TotalRecovered", filterable: false },
      ],

      list: [],
    };
  },
  components: {
    // Form
  },
  methods: {
    readOutLoud: function (msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 0.8;
      speech.pitch = 0.9;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
    },
    getInventoryList: async function () {
      const response = await fetch("https://api.covid19api.com/summary");
      const json = await response.json();
      this.list = json.Countries;
    },
  },
  mounted() {
    this.getInventoryList();
  },
};
</script>

<style scoped>
.theme-bg {
  background: #5351a0;
  color: #fff;
}
.db-content {
  background: #171642;
  height: 100vh;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
h3 {
  color: #888;
}
.title-text {
  font-size: 24px;
  margin: 10px;
}
</style>
